import { formatDate, parseDate } from '../../api/utils';
import ItemIdentifier, { toItemIdentifierQueryParams } from './ItemIdentifier';
import SearchLimitOffset from './SearchLimitOffset';

function parseIdStrings(id: unknown): string[] {
  let ids: string[];
  if (Array.isArray(id)) {
    ids = id.filter((i): i is string => typeof i === 'string');
  } else if (typeof id === 'string') {
    ids = [id];
  } else {
    ids = [];
  }
  return ids;
}

function parseItemImpl(item: string): ItemIdentifier | undefined {
  const result = /^(.+)\s([0][xX][0-9A-Fa-f]+)$/g.exec(item);
  const [, hostName, positionNo] = result ?? [];
  if (hostName == null || positionNo == null) {
    return undefined;
  }
  return { hostName, positionNo };
}

export function parseItem(item: unknown): ItemIdentifier[] {
  return parseIdStrings(item)
    .map(parseItemImpl)
    .filter((i): i is ItemIdentifier => i != null);
}

function isInvalidDateTime(parsedDate: Date, queryDate: string) {
  return (
    Number.isNaN(parsedDate.getTime()) || formatDate(parsedDate) !== queryDate
  );
}

function parseDateTime(datetime: unknown): Date | undefined {
  if (datetime == null || typeof datetime !== 'string') {
    return undefined;
  }
  const parsedDate = parseDate(datetime, 0);
  if (isInvalidDateTime(parsedDate, datetime)) {
    return undefined;
  }
  return parsedDate;
}

export function parseBegin(begin: unknown): Date | undefined {
  return parseDateTime(begin);
}
export function parseEnd(end: unknown): Date | undefined {
  return parseDateTime(end);
}

/**
 * 計測値条件
 */
export default interface SearchValuesRequest extends SearchLimitOffset {
  /**
   * 開始時刻（含む）
   */
  begin: Date;
  /**
   * 終了時刻（含まない）
   */
  end: Date;

  item: ItemIdentifier[];

  info?: boolean;
}

export function toSearchValuesRequestParams(
  request?: SearchValuesRequest,
):
  | (Omit<SearchValuesRequest, 'item'> & {
      item?: string | string[];
    })
  | undefined {
  if (request == null) {
    return undefined;
  }
  const { item, ...rest } = request;
  return {
    ...rest,
    item: toItemIdentifierQueryParams(item),
  };
}
